/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_Dtos_ParticipantLoginLog_ParticipantLoginLogDto } from '../models/Wealthlane_Dtos_ParticipantLoginLog_ParticipantLoginLogDto';
import type { Wealthlane_Dtos_ParticipantLoginLog_UniqueParticipantLoginsDto } from '../models/Wealthlane_Dtos_ParticipantLoginLog_UniqueParticipantLoginsDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantsLoginLogService {

    /**
     * @returns Wealthlane_Dtos_ParticipantLoginLog_ParticipantLoginLogDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiAppParticipantsLoginLogParticipantsTodayLoginLogs(): CancelablePromise<Wealthlane_Dtos_ParticipantLoginLog_ParticipantLoginLogDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/app/participants-login-log/participants-today-login-logs',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_Dtos_ParticipantLoginLog_UniqueParticipantLoginsDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiAppParticipantsLoginLogUniqueParticipantLogins(): CancelablePromise<Array<Wealthlane_Dtos_ParticipantLoginLog_UniqueParticipantLoginsDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/app/participants-login-log/unique-participant-logins',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
